/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/api/',
});

axiosInstance.interceptors.response.use((response) => response,
  (error) => {    
    if (error.response?.status === 401) {
      window.location.href = `/auth/login?returnUrl=${window.location.pathname}`;
      return Promise.reject('401 Unauthorized');
    }
    if (error.response?.status === 403) {
      console.error('403 Forbidden', window.location.href);
      return Promise.reject('403 Forbidden');
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
